module.exports = __webpack_public_path__ + "static/media/percentage-white.868c1a10.svg";